import dayjs from 'dayjs';
const ssc = data => {
  let list = Vue => {
    let arr = Vue.showMobile
      ? [
          {
            title: '日期',
            align: 'center',
            key: 'date',
            className: `table_issueId`,
            width: 150,
            render: (h, { row }) => {
              return <span>{dayjs(row.date).format('MM-DD')}</span>;
            }
          }
        ]
      : [
          {
            title: '日期',
            align: 'center',
            key: 'date',
            className: `table_issueId`,
            width: 150
          }
        ];
    // console.log(data[0].num_history_json, data[20].num_history_json);
    var a = Vue.showMobile
      ? ['冠军', '亚军', '季军', '四名', '五名']
      : ['冠军龙', '冠军虎', '亚军龙', '亚军虎', '第三名龙', '第三名虎', '第四名龙', '第四名虎', '第五名龙', '第五名虎'];
    var b = Vue.showMobile ? ['lh1', 'lh2', 'lh3', 'lh4', 'lh5'] : ['lh1', 'lh1', 'lh2', 'lh2', 'lh3', 'lh3', 'lh4', 'lh4', 'lh5', 'lh5'];
    var str = ['long', 'hu'];

    for (let i = 0; i < 10; i++) {
      if (Vue.showMobile && i == 5) {
        break;
      }
      let obj = {};
      let e = a[i];
      obj.title = `${e}`;
      obj.align = 'center';
      obj.key = 'resultStr';
      obj.className = `table_info_column_${i}`;
      obj.render = (h, row) => {
        var name = b[i];
        return (
          <span>
            {Vue.showMobile
              ? row.row.num_history_json[name]['long'] + '/' + row.row.num_history_json[name]['hu']
              : row.row.num_history_json[name][str[i % 2]]}
          </span>
        );
      };
      arr.push(obj);
    }
    return arr;
  };

  return { list };
};

export default ssc;



// WEBPACK FOOTER //
// ./src/pages/Trend/Longhutongji/columns/pk10.js